// pdfStyles.js
import { StyleSheet } from "@react-pdf/renderer";

const pdfStyles = StyleSheet.create({
  page: {
    fontSize: 12,
    backgroundColor: "#ffffff",
    fontFamily: "Helvetica",
  },

  upBar: {
    width: 600,
    height: 5,
    margin: 0,
    padding: 0,
    backgroundColor: "#00afa9",
  },

  mainDiv: {
    marginTop: 2,
  },

  divTitle: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: 0,
  },

  divTitleAux: {
    flexDirection: "column",
    alignItems: "flex-end",
  },

  image: {
    width: 200,
  },

  divTextVertical: {
    transform: "rotate(-90deg)",
    position: "absolute",
    top: 124,
    left: -38,
    backgroundColor: "#ffffff",
    width: 100,
    justifyContent: "center",
    alignItems: "center",
  },

  verticalText: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#a09d9f",
    backgroundColor: "#ffffff",
    paddingVertical: 4,
    textAlign: "center",
  },

  divMid: {
    position: "relative",
    height: 270,
  },

  divMidInner: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    height: "100%",
  },

  title: {
    fontSize: 16,
    textAlign: "center",
    fontWeight: "bold",
    marginBottom: 0,
    color: "#333",
  },

  subtitle: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "left",
    color: "#e91d75",
  },

  section: {
    marginBottom: 12,
    paddingBottom: 6,
    borderBottom: "1px solid #eee",
  },

  label: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#222",
    marginBottom: 2,
  },

  paragraph: {
    marginBottom: 10,
    lineHeight: 1.4,
    textAlign: "justify",
  },

  imagePlaceholder: {
    height: 150,
    border: "1pt dashed #999",
    marginVertical: 10,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },

  indicadorBox: {
    marginTop: 10,
    marginBottom: 20,
    padding: 10,
    border: "1pt solid #ccc",
  },

  indicadorTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 4,
  },

  // ===== BARRAS (categorias)
  barStack: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 2,
  },

  divBars: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 4,
  },

  divBarsAux: {
    flexDirection: "row",
    alignItems: "center",
  },

  barSection: {
    zIndex: 1,
    border: "1pt solid #ccc",
    borderRadius: 6,
    paddingLeft: 12,
    paddingRight: 5,
    paddingTop: 8,
    paddingBottom: 4,
    marginVertical: 6,
    marginLeft: 16,
    height: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  barRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },

  barLabel: {
    width: 90,
    fontSize: 12,
    fontWeight: "bold",
  },

  barTrack: {
    width: 100,
    height: 12,
    backgroundColor: "#eaeaea",
    borderRadius: 10,
    overflow: "hidden",
    marginRight: 5,
  },

  barFillEntrada: {
    height: 12,
    backgroundColor: "#e91d75",
  },

  barFillSaida: {
    height: 12,
    backgroundColor: "#00afa9",
  },

  barValue: {
    fontSize: 12,
    width: 18,
    textAlign: "right",
  },

  // ===== SCORE BOX + MENTOR
  scoreBox: {
    width: 138,
    marginLeft: 0,
    marginVertical: 10,
    padding: 4,
    backgroundColor: "#fff",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },

  scoreTitle: {
    fontSize: 10,
    fontWeight: "bold",
  },

  scoreItem: {
    fontSize: 10,
    marginBottom: 4,
  },

  upperGraphs: {
    width: "90%",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 4,
  },

  upperGraphsTopRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
  },

  graphDelta: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#009688",
  },

  graphPipe: {
    fontSize: 12,
    color: "#999",
    paddingHorizontal: 2,
  },

  graphDeltaRaw: {
    fontSize: 8,
    color: "#009688",
  },

  upperGraphsCircles: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: 60,
    gap: 5,
    marginTop: 6,
    paddingLeft: 2,
    paddingRight: 2,
    paddingTop: 2,
  },

  graphWithValue: {
    position: "relative",
    width: "45%",
    height: 45,
    alignItems: "center",
  },

  semiGraph: {
    width: "100%",
    height: "100%",
  },

  // semicircular do Mentor para evitar esticar
  semiGraphMentor: {
    width: "60%",
    height: "100%",
  },

  graphValue: {
    position: "absolute",
    top: 12,
    left: 16,
    fontSize: 14,
    fontWeight: "bold",
    color: "#333",
  },

  graphMentorValue: {
    position: "absolute",
    top: 8,
    left: 30,
    fontSize: 14,
    fontWeight: "bold",
    color: "#333",
  },

  graphLabel: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#333",
    marginBottom: 1,
    textAlign: "center",
  },

  graphLine: {
    width: "90%",
    height: 1,
    backgroundColor: "#ccc",
    marginBottom: 4,
    alignSelf: "center",
  },

  // Mentor – um único gráfico centralizado e menor
  mentorGraphs: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 5,
  },

  mentorSingleCircles: {
    width: "100%",
    height: 40,
    alignItems: "center",
    justifyContent: "center",
  },

  mentorSingleWrapper: {
    position: "relative",
    width: "60%",
    height: 45,
    alignItems: "center",
  },

  // ===== INDICADORES
  bottomGraphs: {
    width: "90%",
    flexDirection: "column",
    gap: 5,
    marginTop: 4,
  },

  indicatorBox: {
    padding: 2,
    border: "1pt solid #ccc",
    borderRadius: 6,
    alignItems: "center",
    minWidth: 120,
  },

  indicatorHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 8,
  },

  indicatorPercent: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#333",
  },

  indicatorRaw: {
    fontSize: 7,
    color: "#777",
    marginLeft: 4,
  },

  indicatorCircles: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    gap: 5,
    marginBottom: 4,
    paddingHorizontal: 6,
  },

  circleGraphWrapper: {
    position: "relative",
    width: 35,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
  },

  circleGraph: {
    width: "100%",
    height: "100%",
  },

  circleValue: {
    position: "absolute",
    top: 7,
    left: 9.5,
    fontSize: 10,
    fontWeight: "bold",
    color: "#333",
  },

  circleArrow: {
    position: "absolute",
    bottom: 5,
    left: 14,
    width: 8,
    height: 8,
  },

  indicatorLabelWrapper: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 4,
    marginTop: 2,
  },

  arrowLabelIcon: {
    width: 8,
    height: 8,
  },

  indicatorLabel: {
    fontSize: 7,
    color: "#444",
  },

  indicatorLabelSub: {
    fontSize: 7,
    color: "#444",
  },

  indicatorCategory: {
    fontSize: 9,
    fontWeight: "bold",
    marginTop: 2,
    marginBottom: 2,
  },

  indicatorLine: {
    width: "90%",
    height: 1,
    backgroundColor: "#bbb",
    marginTop: 4,
  },

  // ===== LATERAL (dados do usuário)
  userDataBox: {
    marginLeft: 8,
    marginVertical: 18,
    gap: 16,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    height: "80%",
    width: 160,
  },

  userDataLabel: {
    fontSize: 9,
    fontWeight: "bold",
    marginBottom: 2,
  },

  userDataTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#e91d75",
  },

  legendBox: {
    marginTop: 8,
    gap: 6,
  },

  legendItem: {
    marginBottom: 3,
  },

  legendBar: {
    height: 16,
    width: 120,
    borderRadius: 10,
    justifyContent: "center",
    paddingHorizontal: 8,
  },

  legendText: {
    fontSize: 10,
    color: "#fff",
    fontWeight: "bold",
  },

  legendDate: {
    fontSize: 9,
    color: "#444",
    marginTop: 4,
    marginLeft: 8,
  },

  // ===== BASE – Subcategorias
  divBottom: {
    position: "relative",
    width: "70%",
    marginLeft: 10,
    marginTop: 2,
  },

  aboutBox: {
    marginTop: 10,
    paddingHorizontal: 10,
    width: "90%",
  },

  aboutTitleRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 2,
  },

  aboutIcon: {
    width: 12,
    height: 18,
    marginRight: 6,
  },

  aboutTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#e91e63",
  },

  aboutText: {
    fontSize: 9,
    textAlign: "justify",
    color: "#222",
    lineHeight: 1.25,
  },

  divTextVerticalBottom: {
    transform: "rotate(-90deg)",
    position: "absolute",
    top: 240,
    left: -52,
    backgroundColor: "#ffffff",
    width: 125,
    justifyContent: "center",
    alignItems: "center",
  },

  subBarSection: {
    zIndex: 1,
    border: "1pt solid #ccc",
    borderRadius: 6,
    paddingLeft: 12,
    paddingRight: 5,
    paddingTop: 8,
    paddingBottom: 4,
    marginVertical: 6,
    marginLeft: 0,
    flexDirection: "column",
    justifyContent: "space-between",
  },

  subBarRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },

  subBarLabel: {
    width: 120,
    fontSize: 11,
    fontWeight: "bold",
  },

  // empilhamento (mini-entrada acima / participante / mini-saída abaixo)
  subBarStack: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 0,
  },

  subDivBars: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 0,
  },

  subDivBarsAux: {
    flexDirection: "row",
    alignItems: "center",
  },

  subBarTrack: {
    width: 88,
    height: 12,
    backgroundColor: "#eaeaea",
    borderRadius: 10,
    overflow: "hidden",
    marginRight: 5,
  },

  subBarFillEntrada: {
    height: 12,
    backgroundColor: "#e91d75",
  },

  subBarFillSaida: {
    height: 12,
    backgroundColor: "#00afa9",
  },

  subBarValue: {
    fontSize: 12,
    width: 20,
    textAlign: "right",
  },

  subLabelGroup: {
    width: 90,
    marginRight: 8,
    justifyContent: "center",
  },

  subTitleLabel: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#666",
  },

  subCategoryLabel: {
    fontSize: 11,
    fontWeight: "bold",
    color: "#111",
    marginTop: 2,
  },

  subCircleSection: {
    marginVertical: 8,
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 5,
  },

  // ganhou um pouco mais de altura para suportar as mini-barras
  subDiv: {
    marginTop: 1,
    marginBottom: 1,
    marginLeft: 10,
    flexDirection: "row",
    gap: 5,
    width: 375,
    height: 208,
    padding: 0,
  },

  noteSection: {
    width: "70%",
    marginTop: 8,
    paddingHorizontal: 20,
  },

  noteBar: {
    width: 40,
    height: 4,
    backgroundColor: "#00afa9",
    marginBottom: 6,
  },

  noteText: {
    fontSize: 8,
    color: "#444",
    lineHeight: 1.4,
    textAlign: "justify",
  },

  noteBold: {
    fontWeight: "bold",
    color: "#444",
  },

  sideDecoration: {
    position: "absolute",
    bottom: -13,
    right: 0,
    width: 170,
    height: 550,
    zIndex: 0,
  },

  sideDecorationEntry: {
    position: "absolute",
    bottom: -13,
    right: 0,
    width: 180,
    height: 550,
    zIndex: 0,
  },

  explanationContainer: {
    flexDirection: "column",
    gap: 10,
    paddingHorizontal: 20,
    paddingBottom: 10,
    marginTop: 10,
  },

  explanationBlock: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 10,
  },

  explanationImage: {
    width: 150,
    height: "100%",
    marginTop: 0,
  },

  explanationTextContainer: {
    flexDirection: "column",
    flex: 1,
  },

  explanationTitleRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 3,
    marginBottom: 2,
  },

  explanationIcon: {
    width: 10,
    height: 24,
    marginRight: 6,
  },

  explanationTitle: {
    fontSize: 12,
    color: "#e91e63",
  },

  explanationTitleBold: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#e91e63",
  },

  explanationParagraph: {
    fontSize: 9,
    textAlign: "justify",
    color: "#222",
    lineHeight: 1.25,
  },

  titleDiv: {
    flexDirection: "column",
  },

  floatingLiderancaBox: {
    position: "absolute",
    top: 250,
    right: 0,
    width: 183,
    padding: 8,
    backgroundColor: "#fff",
    boxShadow: "2px 2px 5px rgba(0,0,0,0.1)",
    alignItems: "center",
  },

  floatingInnerLiderancaBox: {
    width: 120,
    alignItems: "center",
  },

  floatingGraphsTopRow: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 6,
  },

  floatingGraphsCircles: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },

  floatingLiderancaBoxEntry: {
    position: "absolute",
    top: 280,
    right: 0,
    width: 191,
    padding: 8,
    backgroundColor: "#fff",
    boxShadow: "2px 2px 5px rgba(0,0,0,0.1)",
    alignItems: "center",
  },

  floatingInnerLiderancaBoxEntry: {
    width: 120,
    alignItems: "center",
  },

  floatingGraphsCirclesEntry: {
    flexDirection: "row",
    alignItems: "center",
  },

  // ===== MINI BARRAS (categorias) — originais
  miniRow: {
    flexDirection: "row",
    alignItems: "center",
  },

  miniValueText: {
    fontSize: 8,
    color: "#e91e63",
    marginLeft: 6,
    minWidth: 22,
    textAlign: "left",
  },

  miniBarsWrapper: {
    marginBottom: 0,
    gap: 1,
  },

  miniBarTrack: {
    width: 100,
    height: 3,
    backgroundColor: "#eee",
    borderRadius: 10,
    overflow: "hidden",
  },

  miniBarFillEntrada: {
    height: 3,
    backgroundColor: "#e91d75",
  },

  miniBarFillSaida: {
    height: 3,
    backgroundColor: "#00afa9",
  },

  // ===== MINI BARRAS

  firstRow:  { marginTop: 1 },
  lastRow:   { marginBottom: 1 },

  firstSubRow: { marginTop: 1 },
  lastSubRow:  { marginBottom: 1 },

  miniBarsWrapperSubFirst: { marginTop: 1 },
  miniBarsWrapperSubLast:  { marginBottom: 1 },

  miniBarsWrapperSub: {
    marginTop: 1,
    marginBottom: 1,
    gap: 0,
  },

  miniRowSub: {
    flexDirection: "row",
    alignItems: "center",
  },

  miniValueTextSub: {
    fontSize: 8,
    color: "#e91e63",
    marginLeft: 6,
    minWidth: 22,
    textAlign: "left",
  },

  miniBarTrackSub: {
    width: 88, // alinha com a largura das barras de subcategoria
    height: 3,
    backgroundColor: "#eee",
    borderRadius: 10,
    overflow: "hidden",
  },

  miniBarFillEntradaSub: {
    height: 3,
    backgroundColor: "#e91d75",
  },

  miniBarFillSaidaSub: {
    height: 3,
    backgroundColor: "#00afa9",
  },
});

export default pdfStyles;
